import React, { useState, useEffect, useRef, useCallback } from 'react';
import style from './DoctorMore.module.css';
import HeadSub from '../../../../../components/comm/HeadSub';
import avatar from '../../../../../images/user/img_sample_docter.png'
import { useLocation, useNavigate } from 'react-router-dom';
import URL from '../../../../../constants/url';
import axiosApi from '../../../../../api/daonAxios';
import CODE from '../../../../../constants/code';
import noDoctorImgPng from '../../../../../images/user/i_3d_hospital_inform_link_01.png';

import ToastPopup from '../../../../../components/comm/ToastPopup';

const PAGE_SIZE = 30;

const DoctorMore = () => {

    const [toast, setToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');

    const location = useLocation();
    const navigate = useNavigate();
    const [doctorList, setDoctorList] = useState([]); //주치의 정보
    const [pageNo, setPageNo] = useState(1);
    const [hasNext, setHasNext] = useState(true);

    const observerRef = useRef(null);
    const scrollObserver = useRef(null);
    const isFirstApiCalled = useRef(false);


    // 결과 호출
    const retrieveUsrPrimaryDoctorList = useCallback(async (pageNo) => {
        const url = "/mypage/retrieveUsrPrimaryDoctorList";
        const jToken = localStorage.getItem('jToken');
        const reqOptions = { headers: { Authorization: jToken } };

        await axiosApi.post(url, {pageNo: pageNo, pageSize: PAGE_SIZE }, reqOptions)
        .then((res) => {
            if (res.data.resultCode === CODE.RCV_SUCCESS) {
                setDoctorList(prev => [...prev, ...res.data.result.doctorList]);
                if (!res.data.result.hasNext) setHasNext(false);
            } else {
                setHasNext(false);
                setToastMessage(res.data.resultMessage);
                setToast(true);
            }
        })
        .catch(err => {
            setHasNext(false);
            console.error("주요검사 결과 호출 중 오류  : ", err);
        })
    }, []);

    // ✅ 최초 한 번만 호출
    useEffect(() => {
        if (!isFirstApiCalled.current) {
        isFirstApiCalled.current = true;
        setTimeout(() => {
            retrieveUsrPrimaryDoctorList(1);
        }, 50);
        }
    }, []);

    // ✅ pageNo 변경 시 (2 이상) 호출
    useEffect(() => {
        if (pageNo > 1 && hasNext) {
        retrieveUsrPrimaryDoctorList(pageNo);
        }
    }, [pageNo]);

    // ✅ observer는 데이터가 렌더링된 이후에만 등록
    useEffect(() => {
        if (!hasNext || doctorList.length === 0) return;

        // 기존 observer 제거
        if (scrollObserver.current && observerRef.current) {
        scrollObserver.current.unobserve(observerRef.current);
        }

        scrollObserver.current = new IntersectionObserver(entries => {
        if (entries[0].isIntersecting) {
            setPageNo(prev => prev + 1);
        }
        }, {
            root: null,
            rootMargin: '0px',
            threshold: 1.0
        });

        if (observerRef.current) {
        scrollObserver.current.observe(observerRef.current);
        }

        return () => {
        if (scrollObserver.current && observerRef.current) {
            scrollObserver.current.unobserve(observerRef.current);
        }
        };
    }, [doctorList.length, hasNext]);

    
    const handleClickDoctor = (deptCd, deptNm, hsptlCd, doctrNo, doctrNm, nuHsptlJbpt, nuSchulJbpt, nuEtcJbpt, nuClnicField) => {
        navigate(URL.HOSPITAL_DOCTORDETAIL, { state: { 
            deptCd: deptCd,
            deptNm: deptNm,
            hosptlCd: hsptlCd,
            doctNo: doctrNo,
            docName: doctrNm,
            hosJbpt: nuHsptlJbpt,
            schJbpt: nuSchulJbpt,
            etcJbpt: nuEtcJbpt,
            docField: nuClnicField,
        }});
    }

    if(!doctorList) return;
    
    return (
        <>
            <HeadSub title="주치의 정보" />

                <div id="sub-content">
                    <div className='inner-wrap' data-pad="normal">

                        <div className={style['doctor-list-box']}>
                            <ul>
                                {doctorList.length === 0 && 
                                    <li className={style['no-data-box']}>
                                        <span>주치의 정보가 없습니다.</span>
                                    </li>
                                }

                                {doctorList.length > 0 && 
                                    doctorList.map((item, _idx)=> {
                                        return (
                                            <li key={_idx} onClick={() => {handleClickDoctor(
                                                    item.deptCd, item.deptNm, item.hsptlCd, item.doctrNo, 
                                                    item.doctrNm, item.nuHsptlJbpt, item.nuSchulJbpt, 
                                                    item.nuEtcJbpt, item.nuClnicField
                                                    )}}>
                                                <div className={style['photo-box']}>

                                                    {!item.doctrImgUrl ? (
                                                        <img
                                                        src={noDoctorImgPng}
                                                        alt="Doctor"
                                                        />
                                                    ) : (
                                                        <img
                                                        src={item.doctrImgUrl}
                                                        alt="Doctor"
                                                        />
                                                    )}
                                                </div>
                                                <div className={style['info-txt-box']}>
                                                    <div className={style['span-box']}>
                                                        <span>{item.hsptlNm}</span>
                                                        <span>{item.deptNm}</span>
                                                    </div>
                                                    <p>{item.doctrNm}</p>
                                                    <span className={style['part-txt']}>{item.clnicCntn}</span>                    
                                                    <span className={style['date']}>{item.clnicDt} 진료</span>
                                                </div>
                                            </li>
                                        )
                                    })
                                }
                                {/* <li>
                                    <div className={style['photo-box']}>
                                        <img src={avatar} alt="" />
                                    </div>
                                    <div className={style['info-txt-box']}>
                                        <div className={style['span-box']}>
                                            <span>여의도성모</span>
                                            <span>간담췌외과</span>
                                        </div>
                                        <p>김대진</p>
                                        <span className={style['part-txt']}>알코올, 니코틴 및 약물/행위 중독, 우울, 불안장애, 수면장애</span>                    
                                        <span className={style['date']}>24.11.27 진료</span>
                                    </div>
                                </li>
                                <li> 
                                    <div className={style['photo-box']}>
                                        <img src={avatar} alt="" />
                                    </div>
                                    <div className={style['info-txt-box']}>
                                        <div className={style['span-box']}>
                                            <span>여의도성모</span>
                                            <span>간담췌외과</span>
                                        </div>
                                        <p>김대진</p>
                                        <span className={style['part-txt']}>알코올, 니코틴 및 약물/행위 중독, 우울, 불안장애, 수면장애</span>                    
                                        <span className={style['date']}>24.11.27 진료</span>
                                    </div>
                                </li>
                                <li>
                                    <div className={style['photo-box']}>
                                        <img src={avatar} alt="" />
                                    </div>
                                    <div className={style['info-txt-box']}>
                                        <div className={style['span-box']}>
                                            <span>여의도성모</span>
                                            <span>간담췌외과</span>
                                        </div>
                                        <p>김대진</p>
                                        <span className={style['part-txt']}>알코올, 니코틴 및 약물/행위 중독, 우울, 불안장애, 수면장애</span>                    
                                        <span className={style['date']}>24.11.27 진료</span>
                                    </div>
                                </li>
                                <li>
                                    <div className={style['photo-box']}>
                                        <img src={avatar} alt="" />
                                    </div>
                                    <div className={style['info-txt-box']}>
                                        <div className={style['span-box']}>
                                            <span>여의도성모</span>
                                            <span>간담췌외과</span>
                                        </div>
                                        <p>김대진</p>
                                        <span className={style['part-txt']}>알코올, 니코틴 및 약물/행위 중독, 우울, 불안장애, 수면장애</span>                    
                                        <span className={style['date']}>24.11.27 진료</span>
                                    </div>
                                </li>
                                <li>
                                    <div className={style['photo-box']}>
                                        <img src={avatar} alt="" />
                                    </div>
                                    <div className={style['info-txt-box']}>
                                        <div className={style['span-box']}>
                                            <span>여의도성모</span>
                                            <span>간담췌외과</span>
                                        </div>
                                        <p>김대진</p>
                                        <span className={style['part-txt']}>알코올, 니코틴 및 약물/행위 중독, 우울, 불안장애, 수면장애</span>                    
                                        <span className={style['date']}>24.11.27 진료</span>
                                    </div>
                                </li>
                                <li>
                                    <div className={style['photo-box']}>
                                        <img src={avatar} alt="" />
                                    </div>
                                    <div className={style['info-txt-box']}>
                                        <div className={style['span-box']}>
                                            <span>여의도성모</span>
                                            <span>간담췌외과</span>
                                        </div>
                                        <p>김대진</p>
                                        <span className={style['part-txt']}>알코올, 니코틴 및 약물/행위 중독, 우울, 불안장애, 수면장애</span>                    
                                        <span className={style['date']}>24.11.27 진료</span>
                                    </div>
                                </li>
                                <li>
                                    <div className={style['photo-box']}>
                                        <img src={avatar} alt="" />
                                    </div>
                                    <div className={style['info-txt-box']}>
                                        <div className={style['span-box']}>
                                            <span>여의도성모</span>
                                            <span>간담췌외과</span>
                                        </div>
                                        <p>김대진</p>
                                        <span className={style['part-txt']}>알코올, 니코틴 및 약물/행위 중독, 우울, 불안장애, 수면장애</span>                    
                                        <span className={style['date']}>24.11.27 진료</span>
                                    </div>
                                </li>
                                <li>
                                    <div className={style['photo-box']}>
                                        <img src={avatar} alt="" />
                                    </div>
                                    <div className={style['info-txt-box']}>
                                        <div className={style['span-box']}>
                                            <span>여의도성모</span>
                                            <span>간담췌외과</span>
                                        </div>
                                        <p>김대진</p>
                                        <span className={style['part-txt']}>알코올, 니코틴 및 약물/행위 중독, 우울, 불안장애, 수면장애</span>                    
                                        <span className={style['date']}>24.11.27 진료</span>
                                    </div>
                                </li>
                                <li>
                                    <div className={style['photo-box']}>
                                        <img src={avatar} alt="" />
                                    </div>
                                    <div className={style['info-txt-box']}>
                                        <div className={style['span-box']}>
                                            <span>여의도성모</span>
                                            <span>간담췌외과</span>
                                        </div>
                                        <p>김대진</p>
                                        <span className={style['part-txt']}>알코올, 니코틴 및 약물/행위 중독, 우울, 불안장애, 수면장애</span>                    
                                        <span className={style['date']}>24.11.27 진료</span>
                                    </div>
                                </li> */}

                            </ul> 
                            <div ref={observerRef} style={{ height: '1px' }} />
                        </div>

                    </div>
                </div>
                {toast && (
                    <ToastPopup
                        setToast={setToast}
                        message={toastMessage}
                        position="center"
                        opacity="90"
                    />
                )}
            
        </>
    );
};

export default DoctorMore;
